import { Component, OnInit } from '@angular/core';
import { BrandProfileService } from './services/brand-profile.service';
import { SharedService } from './services/shared.service';
import { SharedSignalService } from './services/shared-signal.service';
import { IBrandProfile } from './interfaces/brand-profile';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit {
  title = 'walletron-disbursements-ui';

  envRegion!: string;
  sessionId!: string;

  brandStyleCustomProperties: any = {};

  brandProfile!: IBrandProfile;

public constructor(
  private brandProfileService: BrandProfileService,
  private sharedService: SharedService,
  private sharedSignalService: SharedSignalService
  ) {
  }

  ngOnInit(): void {
    // console.log('appComponent - ngOnInit');
  }


  private getBrandProfile() {

    this.brandProfileService.getBrandProfile(this.envRegion, this.sessionId)
    .subscribe({
      next: (response) => {
        if (response) {
          this.brandProfile = response;
          this.sharedService.setBrandProfile(this.brandProfile);

          this.brandStyleCustomProperties = this.sharedService.getBrandStyleScheme(this.brandProfile);
        }
        else {
          console.log("Your session is no loger valid");
          //this.dsbMessage = "Your session is no loger valid.  Please click on the invitation link from the eMail or from your pass in the digital wallet"; //this.sharedService.getCustomizedPrompt("INVALID_SESSION");
          //this.isDsbMessageShown = true;
        }
      },
      error: (error) => {
      },
      complete: () => {
      }
    });
  }
}
